// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UIDIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UIDIcon" ref={forwardedRef} {...props}>
      <path d="M10.8 18.5H9.2v-5.25h1.6z" />
      <path d="M10 5c2.216 0 4.125 1.683 4.125 3.894V17h-1.58V8.894c0-1.211-1.078-2.301-2.545-2.301s-2.545 1.09-2.545 2.3V17h-1.58V8.894C5.875 6.684 7.784 5 10 5" />
      <path d="M5.414 5.475 5.446 5.44A5.73 5.73 0 0 0 4.34 8.837V15.5H2.75V8.837c0-1.699.57-3.26 1.525-4.501z" />
      <path d="M17.25 15.5h-1.589V9.25h1.589z" />
      <path d="M10 8.5c.442 0 .8.355.8.792v2.458H9.2V9.292A.796.796 0 0 1 10 8.5" />
      <path d="M10 1.5c3.632 0 6.65 2.708 7.17 6.25h-1.612C15.055 5.12 12.764 3.123 10 3.123a5.6 5.6 0 0 0-3.552 1.265L5.307 3.246A7.17 7.17 0 0 1 10 1.5" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UIDIcon = /* @__PURE__ */ Object.assign(UIDIconComponent, {
  displayName: 'UIDIcon',
});
